import React, { Component } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import './app.scss';

// Components
import NavBar from '../shared/nav-bar/nav-bar';
import Home from '../home/home';
import AboutUs from '../aboutus/aboutus';
import Gallery from '../gallery/gallery';
import ScrollToTopRoute from '../shared/scroll-to-top-update/scroll-to-top-update'

class App extends Component {
  render() {
    return (
      <Container fluid={true}>
        <Router onUpdate={() => window.scrollTo(0, 0)}>
          <NavBar />
          <Switch>
            <ScrollToTopRoute exact path="/" component={Home} />
            <ScrollToTopRoute path="/aboutus" component={AboutUs} />
            <ScrollToTopRoute path="/gallery" component={Gallery} />
            <ScrollToTopRoute component={Home} />
          </Switch>
        </Router>
      </Container>
    );
  }
}

export default App;
